import fileSaver from 'file-saver';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useNotification } from '@/js/libs/ui/src/V2';

export type FileResponse =
  | { responseCode: 200; data: Blob; headers: { 'x-audienzz-file-name': string } }
  | { responseCode: 204; data: string; headers: null };

export const useSaveFileResponse = () => {
  const notify = useNotification();
  const { t } = useTranslation(['common']);

  return useCallbackRef((response: FileResponse, name?: string) => {
    if (response.responseCode === 200) {
      fileSaver.saveAs(response.data, name ?? decodeURI(response.headers['x-audienzz-file-name']));
      return;
    }
    notify.error({ title: t('common:ERROR'), body: t('common:NO_FILE') });
  });
};
